import { EventEmitter, Injectable } from '@angular/core';
import { Data2Service } from './data2.service';

@Injectable({
  providedIn: 'root'
})
export class ImplementationsService {

    public implementationsEquityFromAPI:any =null;
    public implementationsFixedIncomeFromAPI:any = null;
    public implementationsPresetMixesFromAPI:any = null;
    public apiDataComplete = false;
    public apiCompleteEmitter = new EventEmitter<any>();
    

  constructor(private data2Service:Data2Service) {
    this.data2Service.implementationChoicesEquity$().subscribe(resp=>{
        this.implementationsEquityFromAPI =resp;
        this.apiDone();
    })
     this.data2Service.implementationChoicesFixedIncome$().subscribe(resp=>{
        this.implementationsFixedIncomeFromAPI =resp;
        this.apiDone();
    })
     this.data2Service.implementationPresetMixes$().subscribe(resp=>{
        this.implementationsPresetMixesFromAPI =resp;
        //console.log("implementationPresetMixes", resp)
        this.apiDone();
    })
  }

  private apiDone(){
    if(
        this.implementationsEquityFromAPI!=null 
        && this.implementationsFixedIncomeFromAPI!=null
        && this.implementationsPresetMixesFromAPI!=null ){

            


       for (let i = 0; i < this.implementationsPresetMixesFromAPI.length; i++) {
        this.implementationsPresetMixesFromAPI[i].eIdx = this.implementationsEquityFromAPI.findIndex((x:any)=>x.id==this.implementationsPresetMixesFromAPI[i].equity);
        this.implementationsPresetMixesFromAPI[i].fIdx = this.implementationsFixedIncomeFromAPI.findIndex((x:any)=>x.id==this.implementationsPresetMixesFromAPI[i].fixedincome);
      }  
      this.apiDataComplete=true;   
      this.apiCompleteEmitter.emit(true);
    }
  }



    // public implementationsPreset:any = [
    //           {id:1,routerLink:"/portfolios/{{portfolio}}/implementation/default",e:1,f:1},
    //           {id:5,routerLink:"/portfolios/{{portfolio}}/implementation/core",  e:5,f:2},
    //           {id:3,routerLink:"/portfolios/{{portfolio}}/implementation/large-tilted-portfolios", e:3,f:1},
    //           {id:4,routerLink:"/portfolios/{{portfolio}}/implementation/taxable", e:1,f:2},
    //           {id:6,routerLink:"/portfolios/{{portfolio}}/implementation/mid-cap-portfolios", e:6,f:1},
    //           {id:7,routerLink:"/portfolios/{{portfolio}}/implementation/high-profitability-taxable", e:7,f:1},
    //           {id:8,routerLink:"/portfolios/{{portfolio}}/implementation/etf-factor-based-multi-manager", e:8,f:5},
    //           {id:9,routerLink:"/portfolios/{{portfolio}}/implementation/etf-factor-neutral", e:9,f:5},
    //           {id:10,routerLink:"/portfolios/{{portfolio}}/implementation/etf-vanguard",  e:10,f:5},
    //           {id:11,routerLink:"/portfolios/{{portfolio}}/implementation/etf-avantis", e:11,f:4},
    //           {id:12,routerLink:"/portfolios/{{portfolio}}/implementation/diversified-index-managers", e:12,f:7},
    //           //   {id:13,routerLink:"/portfolios/{{portfolio}}/implementation/global-extended-fixed-income", e:2,f:8},
    //           //   {id:14,routerLink:"/portfolios/{{portfolio}}/implementation/sustainable", e:13,f:9},
    //           //   {id:15,routerLink:"/portfolios/{{portfolio}}/implementation/socially-responsible", e:14,f:10},
    //           {id:16,routerLink:"/portfolios/{{portfolio}}/implementation/catholic-values", e:15,f:11},
    //           {id:2,routerLink:"/portfolios/{{portfolio}}/implementation/tax-deferred", e:2,f:1},
    // ]
  

  
    // public implementationsEquity = [  
    //   { id:1,label: 'IFA Default Equity',fundType:'ETFs', manager:'Multi-Manager', logoHeight:22, logo:'multi-manager',portSuffix:'_ifa', style:'Small/Value/Prof'},  
    //   { id:5,label2: 'Core Plus Equities',fundType:'ETFs', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'cp_ifa', style:'Large/Prof/Core' },  
    //   //{ id:4,label2: 'Equities',fundType:'ETFs', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'t_ifa', style:'Prof/Small/Value'  },  
    //   { id:7,label: 'High Profitability Equities',fundType:'ETFs', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'hpt_ifa', style:'Small/Prof/Value' },  
    //   { id:11,label2: 'Equities',fundType:'ETFs', manager:'Avantis', logoHeight:24,logo:'avantis',portSuffix:'av2024_ifa', style:'Small/Value'},  
    //   { id:10,label2: 'Equities',fundType:'ETFs', manager:'Vanguard', logoHeight:24,logo:'vanguard',portSuffix:'vanetf_ifa', style:'Small/Value'  },
    //   { id:16,label2: 'Equities',fundType:'ETFs', manager:'Vanguard', logoHeight:24,logo:'vanguard',portSuffix:'vlv_ifa', style:'Large/Value'  },    
    //   { id:18,label2: 'Equities',fundType:'ETFs', manager:'Blackrock', logoHeight:24,logo:'blackrock',portSuffix:'ishsv_ifa', style:'Small/Value'  },    
    //   { id:20,label2: 'Equities',fundType:'ETFs', manager:'Blackrock', logoHeight:24,logo:'blackrock',portSuffix:'ishmc_ifa', style:'Mid/Value'  },    
    //   { id:19,label2: 'Equities',fundType:'ETFs', manager:'Blackrock', logoHeight:24,logo:'blackrock',portSuffix:'ishlv_ifa', style:'Large/Value'  },    
    //   { id:17,label: 'Equities - E',fundType:'ETFs Mutual Funds',manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'mkhg_ifa', style:'Large/Value/Metals'  },  
    //   { id:3,label2: 'Equities',fundType:'ETFs', manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'lt_ifa', style:'Large/Prof/Value' },     
    //   { id:6,label2: 'Equities',fundType:'ETFs', manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'mt_ifa', style:'Large/Mid/Small/Value' },  
    //   { id:8,label2: 'Equities',fundType:'ETFs', manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'etf_ifa', style:'Large/Mid/Small/Value'  },  
    //   { id:9,label2: 'Equities',fundType:'ETFs', manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'etfn_ifa', style:'Large/Blend' },  
    //   { id:12,label2: 'Equities',fundType:'Mutual Funds', manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'d_ifa', style:'Small/Value' },        
    //   { id:13,label: 'Sustainable Equities',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'ec2021_ifa', style:'Large/Core' },  
    //   { id:14,label: 'Socially Responsible Equities',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'sr_ifa', style:'Large/Core' },  
    //   { id:15,label: 'Catholic Values Equities',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'sr_ifa', style:'Large/Core' },
    //   { id:2,label: '401(k) Equity',fundType:'Mutual Funds',manager:'Multi-Manager', logoHeight:22,logo:'multi-manager',portSuffix:'td_ifa', style:'Small/Value/Prof'  }, 
 

      
    // ];  

    
  
    //  public implementationsFixedIncome = [  
    //      { id:1,label: 'IFA Default Fixed Income', label2:'',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'_ifa',securityType:'Short-term/Mixed' },  
    //      { id:2,label: 'IFA Default Fixed Income', label2:'',fundType:'ETFs',manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'cp_ifa', securityType:'Short-term/Mixed' },   //CORE PLUS
    //      { id:6,label: 'Core Plus', label2:'Fixed Income',fundType:'ETFs', manager:'Dimensional',logoHeight:25,logo:'dimensional',portSuffix:'cp_ifa', securityType:"Interm/Mixed" },  
    //     // { id:3,label: '', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'hpt_ifa', securityType:"Short-term/Mixed" },
    //      { id:8,label: 'Global Extended', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'gefi_ifa', securityType:"Broad/Mixed"  },
    //      { id:16,label: 'Fixed Income - E', label2:'',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'mkhg_ifa',securityType:'Short-term/Tips' },  
    //      { id:9,label: 'Sustainable', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'ec2021_ifa', securityType:"Broad/Mixed" },
    //      { id:10,label: 'Social', label2:'Fixed Income',fundType:'Mutual Funds',manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'sr_ifa', securityType:"Broad/Mixed" },
    //      { id:11,label: 'Catholic Values', label2:'Fixed Income',fundType:'Mutual Funds',manager:'Dimensional', logoHeight:25,logo:'dimensional',portSuffix:'sr_ifa', securityType:"Broad/Mixed" },
    //      { id:4,label: 'Core', label2:'Fixed Income',fundType:'ETFs',manager:'Avantis', logoHeight:24,logo:'avantis',portSuffix:'av2024_ifa', securityType:"Interm/Mixed" },  
    //      { id:5,label: 'Total Bond Market', label2:'Fixed Income',fundType:'ETFs', manager:'Vanguard', logoHeight:24,logo:'vanguard',portSuffix:'vanetf_ifa', securityType:"Broad/Mixed" },  
    //      { id:13,label: 'NY Muni', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Vanguard', logoHeight:24,logo:'vanguard',portSuffix:'nymb_ifa', securityType:"Long-term/Muni" },  
    //      { id:15,label: 'National Muni', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Vanguard', logoHeight:24,logo:'vanguard',portSuffix:'m_ifa', securityType:"Interm/Muni" },  
    //     { id:17,label: '', label2:'Fixed Income',fundType:'ETFs', manager:'blackrock', logoHeight:24,logo:'blackrock',portSuffix:'ishsv_ifa', securityType:"Short-term/Mixed" },  
    //      //{ id:17,label2: 'EqFixed Income',fundType:'ETFs', manager:'Blackrock', logoHeight:24,logo:'blackrock',portSuffix:'ishsv_ifa', securityType:'Short-term/Mixed'  },  
    //      { id:12,label: 'CA Muni', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Multi-Manager',logoHeight:22,logo:'multi-manager',portSuffix:'camb_ifa', securityType:"Interm/Muni" },  
    //      { id:7,label: '', label2:'Fixed Income',fundType:'Mutual Funds', manager:'Multi-Manager',logoHeight:22,logo:'multi-manager',portSuffix:'d_ifa', securityType:"Interm/Mixed" },  
    // //{ id:14,label: 'NY Muni', label2:'Fixed Income',fundType:'Mutual Funds',  manager:'Multi-Manager',portSuffix:'m_ifa', securityType:"Long Muni" },  //TODO 2025-08-26 Make the iShares/Vanguard version
    // ]; 

    public addRowspans(data: any[], keys: string[]) {  
      const rows = data.map(r => ({ ...r })); // clone so we don’t mutate  
      
      keys.forEach((key) => {  
        let i = 0;  
        while (i < rows.length) {  
          let count = 1;  
      
          for (let j = i + 1; j < rows.length; j++) {  
            // Must match the key value  
            if (rows[j][key] !== rows[i][key]) break;  
      
            // Special case: if key is "size", region must also match  
            if (key === 'size' && rows[j]['region'] !== rows[i]['region']) break;  
            if (key === 'style' && (rows[j]['size'] !== rows[i]['size'] || rows[j]['region'] !== rows[i]['region'])) break; 
    
            if (key === 'maturity' && rows[j]['region'] !== rows[i]['region']) break;  
            if (key === 'security_type' && (rows[j]['maturity'] !== rows[i]['maturity'] || rows[j]['region'] !== rows[i]['region'])) break; 
      
            count++;  
          }  
      
          // First row in this group gets the rowspan count  
          rows[i][`${key}_rowspan`] = count;  
      
          // Mark the rest so we hide them  
          for (let k = i + 1; k < i + count; k++) {  
            rows[k][`${key}_rowspan`] = 0;  
          }  
      
          i += count;  
        }  
      });  
      
      return rows;  
    }  

    public logo(manager: string) {
        switch (manager) {
            case "Dimensional": {
                return {
                    height: 35,
                    src: "dimensional.svg"
                };
            }
            case "Vanguard": {
                return {
                    height: 35,
                    src: "vanguard.svg"
                };
            }
            case "Avantis": {
                return {
                    height: 35,
                    src: "avantis.svg"
                };
            }
            case "Black Rock": {
                return {
                    height: 30,
                    src: "blackrock.svg"
                };
            }
            case "Invesco": {
                return {
                    height: 35,
                    src: "invesco.svg"
                };
            }

            case "Schwab": {
                return {
                    height: 35,
                    src: "schwab.svg"
                };
            }
            case "State Street": {
                return {
                    height: 35,
                    src: "state-street.svg"
                };
            }
            case "Vert": {
                return {
                    height: 35,
                    src: "vert.svg"
                };
            }
            case "Multi-Manager": {
                return {
                    height: 35,
                    src: "multi-manager.svg"
                };
            }
             case "VanEck": {
                return {
                    height: 35,
                    src: "vaneck.svg"
                };
            }
            default: {
                console.log("NO LOGO",manager)
                return null;
            }
        }
    }
}
